export const contactInfo = {
  phoneDisplay: "(615) 553-6787",
  phoneHref: "tel:+16155536787",
  email: "info@psprcm.us",
  emailHref: "mailto:info@psprcm.us",
  address: "1616 Westgate Circle Brentwood, TN 37027",
  addressMapHref:
    "https://maps.app.goo.gl/SjLx2pm2yPSvzneSA",
};

